module.exports = __webpack_public_path__ + "static/img/06.eb47a92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/06.jpg
// module id = Ti6H
// module chunks = 1